import styles from '@features/homepage/sections/Voxbox/VoxboxSection.styles';
import { IVoxboxObject } from '@features/cms/typescript';
import VoxboxSectionContent from '@features/homepage/sections/Voxbox/VoxboxSectionContent';
type PropsType = {
  voxbox: IVoxboxObject;
  isFirst?: boolean;
};
const VoxboxSection = ({
  voxbox,
  isFirst = false
}: PropsType) => {
  const {
    thumbnail,
    link,
    blur,
    content,
    buttonText,
    video
  } = voxbox;
  return <section sx={styles.section} data-testid="VoxboxSection">
      <div sx={styles.block} data-testid="VoxboxSectionBlock">
        <VoxboxSectionContent video={video} thumbnail={thumbnail} link={link} blur={blur} content={content} buttonText={buttonText} isFirst={isFirst} />
      </div>
    </section>;
};
export default VoxboxSection;